import React, { useState, useEffect } from "react";
import { Col, Row, Form } from "react-bootstrap";
import { Input, Modal, Space, Button, Checkbox } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { useParams } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import { getRestoLogin, toastStyle } from "../../Helpers/Utils/Common";

// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { getAllServices } from "../../Helpers/apiCalls/servicesApi";

//components
// import Table from "../../Components/Table/Table";
import Table from "../../Components/TableTemplate/Table";
import DeleteModal from "../../Components/Modals/DeleteModal";
import AddModal from "../../Components/Modals/AddModal";
import ViewModal from "../../Components/Modals/ViewModal";
import ResetModal from "../../Components/Modals/ResetModal";
import EditModal from "../../Components/Modals/EditModal";
import InputError from "../../Components/InputError/InputError";
import NavbarAdmin from "../../Components/NavbarAdmin/NavbarAdmin";
//css
import "./UserManager.css";

//api
import { refreshPage } from "../../Helpers/Utils/Common";
import { validateUsers } from "../../Helpers/Validation/Manage/UsersValidation";
import {
  createUser,
  deleteUser,
  updateUser,
  resetPassword,
} from "../../Helpers/apiCalls/usersApi";
import { UseGetRequest } from "../../Helpers/hooks/GetRequests";
import { usePostRequest } from "../../Helpers/hooks/usePostRequest";

const modules = [
  { key: "Categories" },
  { key: "Closed Invoice" },
  { key: "Discounts" },
  { key: "Menus" },
  { key: "Ordering Station" },
  { key: "Users" },
  {
    key: "Reports",
    submodules: [
      { key: "Audit Trails" },
      { key: "Cancelled Report" },
      { key: "Cash Counts" },
      { key: "Cashier Sales (X Reading)" },
      { key: "Category Report" },
      { key: "EJournal" },
      { key: "Financial Report" },
      { key: "Item History" },
      { key: "Other Discount Sales" },
      { key: "Payment Report" },
      { key: "PWD Sales" },
      { key: "Receiving Report" },
      { key: "Resto Item Sales Report" },
      { key: "Sales" },
      { key: "Senior Citizen Sales" },
      { key: "Z Reading" },
    ],
  },
];

export default function Users() {
  const { callPost, isLoading } = usePostRequest(() => {});
  const [inactive, setInactive] = useState(false);
  const [option, setOption] = useState("Select");
  const [isClicked, setIsClicked] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [selectedRow, setSelectedRow] = useState({});

  // MODALS //
  // DELETE
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const handleShowDeleteModal = () => setShowDeleteModal(true);
  const handleCloseDeleteModal = () => setShowDeleteModal(false);

  // VIEW
  const [showViewUserModal, setShowViewUserModal] = useState(false);
  const handleShowViewUserModal = () => setShowViewUserModal(true);
  const handleCloseViewUserModal = () => setShowViewUserModal(false);

  // EDIT
  const [showEditUserModal, setShowEditUserModal] = useState(false);
  const handleShowEditUserModal = () => setShowEditUserModal(true);
  const handleCloseEditUserModal = () => setShowEditUserModal(false);

  // EDIT
  const [showResetUserModal, setShowResetUserModal] = useState(false);
  const handleShowResetUserModal = () => setShowResetUserModal(true);
  const handleCloseResetUserModal = () => setShowResetUserModal(false);

  // ADD
  const [showAddUserModal, setShowAddUserModal] = useState(false);
  const handleShowAddUserModal = () => setShowAddUserModal(true);
  const handleCloseAddUserModal = () => setShowAddUserModal(false);
  const [openPermission, setOpenPermission] = useState(false);
  const [selectedPermissions, setSelectedPermissions] = useState([]);
  const [selectedReports, setSelectedReports] = useState([]);

  //API
  const [resetPasswordData, setResetPasswordData] = useState({
    password: "",
    confirm_password: "",
  });
  const [usersData, setUsersData] = useState([]);
  const [userData, setUserData] = useState({});
  const [editUser, setEditUser] = useState({});
  const [userDetails, setUserDetails] = useState({
    full_name: "",
    email: "",
    type: "",
    username: "",
    password: "",
    confirm_password: "",
    role_id: "",
  });

  //REQUIRED ERROR HANDLING
  const [isError, setIsError] = useState({
    full_name: false,
    email: false,
    role_id: false,
    username: false,
    password: false,
    confirm_password: false,
  });

  //ONCHANGE
  //ADD or CREATE USER
  const handleAddChange = (e) => {
    const { name, value } = e.target;
    setUserDetails((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  //RESERT PASSWORD
  const handleResetChange = (e) => {
    const { name, value } = e.target;
    setResetPasswordData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  //EDIT or UPDATE USER
  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditUser((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    setUserData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  //onEdit
  function handleOnEdit() {
    handleCloseViewUserModal();
    handleShowEditUserModal();
  }

  // SEARCH USER
  function handleOnSearch(e) {
    searchUsers(e.target.value);
  }

  //DROPDOWN
  function handleSelectChange(e, row) {
    setSelectedRow(row);
    setEditUser(row);
    setUserData(row);
    if (e.target.value === "delete-user") {
      handleShowDeleteModal();
    } else if (e.target.value === "edit-user") {
      handleShowEditUserModal();
    } else if (e.target.value === "view-user") {
      handleShowViewUserModal();
    } else if (e.target.value === "reset-user") {
      handleShowResetUserModal();
    } else if (e.target.value === "permission") {
      setOpenPermission(true);
    } else {
      refreshPage();
    }
  }

  function ActionBtn(row) {
    return (
      <Form.Select
        name="action"
        className="PO-select-action form-select"
        id={row.id}
        onChange={(e) => handleSelectChange(e, row)}
        value={option}
      >
        <option defaulValue selected hidden>
          Select
        </option>
        {/* <option value="view-user" className="color-options">
          View
        </option> */}
        <option value="edit-user" className="color-options">
          Edit
        </option>
        <option value="delete-user" className="color-red">
          Delete
        </option>
        <option value="reset-user" className="color-red">
          Reset Password
        </option>
        {/* <option value="permission" className="color-red">
          Permissions
        </option> */}
      </Form.Select>
    );
  }

  // Get All Users
  async function fetchAllUsers() {
    setShowLoader(true);
    // const response = await getAllUsers();
    const response = await UseGetRequest("users/getAll", {}, getRestoLogin());
    if (response.data) {
      setUsersData(response.data.users);
    } else {
      setUsersData([]);
    }
    setTimeout(() => setShowLoader(false), 1000);
  }

  async function searchUsers(name) {
    setShowLoader(true);
    // const response = await searchUser(name);
    const response = await UseGetRequest(
      "users/search",
      { term: name },
      getRestoLogin()
    );
    if (response.data) {
      setUsersData(response.data);
    } else {
      setUsersData([]);
    }
    setTimeout(() => setShowLoader(false), 1000);
  }

  //Create API Discount
  async function create() {
    if (validateUsers(userDetails, setIsError)) {
      if (userDetails.password === userDetails.confirm_password) {
        if (userDetails.password.length >= 6) {
          setIsClicked(true);
          const response = await createUser(userDetails, getRestoLogin());
          if (response.data) {
            toast.success("Successfully Created User!", {
              style: toastStyle(),
            });
            //  handleCloseAddModal();
            refreshPage();
          } else {
            toast.error(response.error.data.messages.error, {
              style: toastStyle(),
            });
          }
        } else {
          toast.error("Password must be atleast 6 characters!", {
            style: toastStyle(),
          });
        }
      } else {
        toast.error("Password does not match!", { style: toastStyle() });
      }
    } else {
      toast.error("An error has occured!", { style: toastStyle() });
    }
  }

  //EDIT or UPDATE DISCOUNT
  async function update() {
    if (validateUsers(editUser, setIsError)) {
      const response = await updateUser(editUser, getRestoLogin());
      if (response.data) {
        toast.success("Successfully Updated User!", { style: toastStyle() });
        // handleCloseEditDiscountModal()
        refreshPage();
      } else {
        toast.error("Error Updating New User", { style: toastStyle() });
      }
    } else {
      toast.error("An error has occured!", { style: toastStyle() });
    }
  }

  async function reset() {
    if (validateUsers(resetPasswordData, setIsError)) {
      if (resetPasswordData.password === resetPasswordData.confirm_password) {
        if (resetPasswordData.password.length >= 3) {
          const response = await resetPassword(
            resetPasswordData,
            userData,
            getRestoLogin()
          );
          if (response.data) {
            toast.success("Successfully Reset Password!", {
              style: toastStyle(),
            });
            // handleCloseEditDiscountModal()
            refreshPage();
          } else {
            toast.error("Error Updating Reset Password", {
              style: toastStyle(),
            });
          }
        } else {
          toast.error("Password must be atleast 6 characters!", {
            style: toastStyle(),
          });
        }
      } else {
        toast.error("Password does not match!", { style: toastStyle() });
      }
    } else {
      toast.error("An error has occured!", { style: toastStyle() });
    }
  }

  //DELETE or REMOVE MENU
  async function handleDeleteUser() {
    const response = await deleteUser(selectedRow.id, getRestoLogin());
    if (response.data) {
      toast.success("Successfully Deleted User!", { style: toastStyle() });
      // handleCloseDeleteModal();
      refreshPage();
    } else {
      toast.error(response.error.data.messages.error, { style: toastStyle() });
    }
  }

  async function handleSubmitPermission() {
    alert("INTEGRATE");
  }

  useEffect(() => {
    fetchAllUsers();
  }, []);

  return (
    <div>
      <Toaster position="top-right" reverseOrder={false} />
      <NavbarAdmin
        onCollapse={(inactive) => {
          setInactive(inactive);
        }}
        active={"Users"} //Dashboard navbar index
        page={"Users"}
      />
      <div className={`container ${inactive ? "inactive" : "active"}`}>
        <Row className="mb-3">
          <Col xs={6}>
            <label className="page-title-menu"> USER MANAGER </label>
          </Col>
          <Col xs={4} className="d-flex justify-content-end">
            <Input
              // style={{ width: 250 }}
              suffix={<SearchOutlined />}
              placeholder="Search user"
              className=""
              onKeyDown={(e) =>
                e.key === ("Enter" || "NumpadEnter") && handleOnSearch(e)
              }
              onChange={(e) => handleOnSearch(e)}
            />
          </Col>
          <Col xs={2}>
            <button className="category-new-export-btn" onClick={handleShowAddUserModal}>
              Add
            </button>
          </Col>
        </Row>
        <div>
          {/* TABLE */}
          <Table
            tableHeaders={["FULL NAME", "USERNAME", "ROLE", "ACTIONS"]}
            headerSelector={[
              "full_name",
              "username",
              "role",
              // " ",
            ]}
            tableData={usersData}
            ActionBtn={(row) => ActionBtn(row)}
            showLoader={showLoader}
          />
        </div>
      </div>
      {/* MODALS */}
      <DeleteModal
        text="user"
        show={showDeleteModal}
        onHide={handleCloseDeleteModal}
        onDelete={handleDeleteUser}
      />
      {/* <AddModal title="USER" type="user" show={showAddUserModal} onHide={handleCloseAddUserModal} onSave={handleSaveUser}> */}
      <AddModal
        title="USER"
        type="user"
        show={showAddUserModal}
        onHide={handleCloseAddUserModal}
        onSave={create}
        size="lg"
      >
        <div className="mt-3 edit-form">
          <Row className="nc-modal-custom-row mt-0">
            <Col>
              NAME
              <span className="required"> * </span>
              <Form.Control
                type="text"
                name="full_name"
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
              <InputError
                isValid={isError.full_name}
                message={"Name is required"}
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row">
            <Col>
              USERNAME
              <span className="required"> * </span>
              <Form.Control
                type="text"
                name="username"
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
              <InputError
                isValid={isError.username}
                message={"Username is required"}
              />
            </Col>
            <Col>
              ROLE
              <span className="required"> * </span>
              <select
                name="role_id"
                className="nc-modal-custom-select"
                defaultValue="Select"
                onChange={(e) => handleAddChange(e)}
                required
              >
                <option defaulValue selected hidden>
                  Select
                </option>
                <option value="1">Manager</option>
                <option value="2">Cashier</option>
                <option value="8">Server</option>
              </select>
              <InputError
                isValid={isError.role_id}
                message={"User Type is required"}
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row">
            <Col>
              PASSWORD
              <span className="required"> * </span>
              <Form.Control
                type="password"
                name="password"
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
              <InputError
                isValid={isError.password}
                message={"Password is required"}
              />
            </Col>
            <Col>
              CONFIRM PASSWORD
              <span className="required"> * </span>
              <Form.Control
                type="password"
                name="confirm_password"
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
              <InputError
                isValid={isError.confirm_password}
                message={"Confirm Password is required"}
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row">
            <Col>
              <span className="required"> * </span>
              <span className="required"> required fields </span>
            </Col>
          </Row>
        </div>
      </AddModal>
      {/* <EditModal title="USER" type="user" show={showEditUserModal} onHide={handleCloseEditUserModal} onSave={handleEditUser}> */}
      <EditModal
        title="USER"
        type="user"
        show={showEditUserModal}
        onHide={handleCloseEditUserModal}
        onSave={update}
        size="lg"
      >
        <div className="mt-3 edit-form">
          <Row className="nc-modal-custom-row mt-0">
            <Col>
              NAME
              <span className="required"> * </span>
              <Form.Control
                type="text"
                name="full_name"
                value={editUser.full_name}
                className="nc-modal-custom-input-edit"
                onChange={(e) => handleEditChange(e)}
                required
              />
              <InputError
                isValid={isError.full_name}
                message={"First name is required"}
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row">
            <Col>
              USERNAME
              <span className="required"> * </span>
              <Form.Control
                type="text"
                name="username"
                value={editUser.username}
                className="nc-modal-custom-input-edit"
                onChange={(e) => handleEditChange(e)}
                required
              />
              <InputError
                isValid={isError.username}
                message={"Username is required"}
              />
            </Col>
            <Col>
              ROLE
              <span className="required"> * </span>
              <select
                name="role_id"
                className="nc-modal-custom-select"
                defaultValue="Select"
                value={editUser.role_id}
                onChange={(e) => handleEditChange(e)}
                required
              >
                <option defaulValue selected>
                  Select
                </option>
                <option value="1">Manager</option>
                <option value="2">Cashier</option>
                <option value="8">Server</option>
              </select>
              <InputError
                isValid={isError.role_id}
                message={"User role is required"}
              />
            </Col>
          </Row>
        </div>
      </EditModal>

      <ResetModal
        title="PASSWORD"
        type="user"
        show={showResetUserModal}
        onHide={handleCloseResetUserModal}
        onSave={reset}
        size="lg"
      >
        <div className="mt-3 edit-form">
          <Row className="nc-modal-custom-row">
            <Col xs={"12"}>
              PASSWORD
              <span className="required"> * </span>
              <Form.Control
                type="password"
                name="password"
                autoComplete="off"
                className="nc-modal-custom-input-edit"
                onChange={(e) => handleResetChange(e)}
                required
              />
              <InputError
                isValid={isError.password}
                message={"Password is required"}
              />
            </Col>
            <Col xs={12} className="mt-2">
              CONFIRM PASSWORD
              <span className="required"> * </span>
              <Form.Control
                type="password"
                autoComplete="off"
                name="confirm_password"
                className="nc-modal-custom-input-edit"
                onChange={(e) => handleResetChange(e)}
                required
              />
              <InputError
                isValid={isError.confirm_password}
                message={"Confirm Password is required"}
              />
            </Col>
          </Row>
        </div>
      </ResetModal>

      <ViewModal
        withButtons
        show={showViewUserModal}
        onHide={handleCloseViewUserModal}
        onEdit={handleOnEdit}
        size="lg"
      >
        <div>
          <div className="col-sm-12 space">
            <span className="custom-modal-body-title-user-details">
              USER DETAILS
            </span>
            <div className="mt-3 container-wrapper">
              <Row className="nc-modal-custom-row-view">
                <Col className="text-start" xs={4}>
                  FULL NAME <br/>
                  {editUser.full_name}
                </Col>
                <Col className="text-start" xs={4}>
                  USERNAME <br/>
                  {editUser.username}
                </Col>
                <Col className="text-start" xs={4}>
                  ROLE <br/>
                  {editUser.role}
                </Col>
             
              </Row>
            </div>
          </div>
        </div>
      </ViewModal>

      <Modal
        closeIcon={false}
        footer={false}
        open={openPermission}
        onCancel={() => {
          setSelectedPermissions([]);
          setSelectedReports([]);
          setOpenPermission(false);
        }}
        title="Set User Permission"
      >
        <div className="primary-font">
          {modules.map((item) =>
            item.submodules && selectedPermissions.includes("Reports") ? (
              <div>
                <Row>
                  <Checkbox
                    checked={selectedPermissions.includes(item.key)}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setSelectedPermissions([
                          ...selectedPermissions,
                          item.key,
                        ]);
                      } else {
                        const newSet = selectedPermissions.filter(
                          (per) => per !== item.key
                        );
                        setSelectedPermissions(newSet);
                        setSelectedReports([]);
                      }
                    }}
                  >
                    {item.key}
                  </Checkbox>
                </Row>
                {item.submodules.map((sub) => (
                  <Row className="ms-3">
                    <Checkbox
                      checked={selectedReports.includes(sub.key)}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setSelectedReports([...selectedReports, sub.key]);
                        } else {
                          const newSet = selectedReports.filter(
                            (per) => per !== sub.key
                          );
                          setSelectedReports(newSet);
                        }
                      }}
                    >
                      {sub.key}
                    </Checkbox>
                  </Row>
                ))}
              </div>
            ) : (
              <Row>
                <Checkbox
                  checked={selectedPermissions.includes(item.key)}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setSelectedPermissions([
                        ...selectedPermissions,
                        item.key,
                      ]);
                    } else {
                      const newSet = selectedPermissions.filter(
                        (per) => per !== item.key
                      );
                      setSelectedPermissions(newSet);
                    }
                  }}
                >
                  {item.key}
                </Checkbox>
              </Row>
            )
          )}
        </div>
        <hr />
        <Space className="d-flex justify-content-end w-100 p-0 mt-3">
          <Button
            className="me-2 px-4 py-3"
            onClick={() => {
              setSelectedPermissions([]);
              setOpenPermission(false);
              setSelectedReports([]);
            }}
          >
            CANCEL
          </Button>
          <Button
            type="primary"
            className="px-4 py-3"
            onClick={handleSubmitPermission}
            disabled={
              selectedPermissions.length === 0 ||
              (selectedPermissions.includes("Reports") &&
                selectedReports.length === 0)
            }
          >
            SUBMIT
          </Button>
        </Space>
      </Modal>

      <div>
        <label className="powered-label pt-3 text-center">
          Powered by MYT SofDev Solutions Inc. EPSOS 1.0.0
        </label>
      </div>
    </div>
  );
}
